import { AddMedicalHistory } from "@/common/types";
import axiosInstance from "./axiosInstance";
import publicAxiosInstance from "./publicAxiosInstance";

export const getUsersApi = (
  role: string = "",
  doctorId: string = "",
  search: string = "",
  page?: number,
  pageSize?: number
) => {
  let queryParam = `${role && `role=${role}&`}${search && `name=${search}`}${
    doctorId && `&associated_doctor=${doctorId}`
  }`;
  if (page) {
    queryParam = queryParam + `&page=${page}`;
  }
  if (pageSize) {
    queryParam = queryParam + `&size=${pageSize}`;
  }
  const response = axiosInstance.get(
    `/users/${queryParam && `?${queryParam}`}`
  );
  return response;
};

export const getDoctorDetailByIdApi = (id: number) => {
  const response = axiosInstance.get(`/doctors/${id}`);
  return response;
};

export const getPatientDetailByIdApi = (id: number) => {
  const response = axiosInstance.get(`/patients/${id}`);
  return response;
};

export const acceptInvitationApi = (token: string, password: string) => {
  const response = publicAxiosInstance.post(`/users/accept-invitation/`, {
    token,
    password,
  });
  return response;
};

export const inviteUserApi = (
  name: string,
  email: string,
  role: string,
  doctor: number | null
) => {
  let payload: any = {
    name,
    email,
    role,
  };
  if (role === "patient") {
    payload = {
      ...payload,
      associated_doctor: doctor,
    };
  }
  const response = axiosInstance.post(`/users/invite/`, payload);
  return response;
};

export const getInviteesApi = () => {
  const response = axiosInstance.get(`/users/invites/`);
  return response;
};

export const deleteInvitedUserApi = (userId: number) => {
  const response = axiosInstance.delete(`/users/invites/${userId}`);
  return response;
};

export const getMedicalHistoryApi = (id: number) => {
  const response = axiosInstance.get(`/medical-history/?patient=${id}`);
  return response;
};

export const addMedicalHistoryApi = (medicalHistory: AddMedicalHistory) => {
  const response = axiosInstance.post("/medical-history/", medicalHistory);
  return response;
};
